/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import {
  renderDefaultError,
  renderDefaultLoading,
  SmartComponentProps
} from '@exo/frontend-common-utils';
import { useFooter } from '../../hooks/useFooter';
import { getAppLanguage } from '@exo/frontend-common-utils';

export const FooterContainer = ({
  render,
  renderLoading = renderDefaultLoading,
  renderError = renderDefaultError
}: Props) => {
  // GENERATOR: This is a noop you need to replace
  //this is dev footer ID : 1lDkzynrNmWNpdEc4VOWxr
  const footerID = process.env.FOOTER_ID!;
  const { loading, data, error } = useFooter({ footerId: footerID, locale: getAppLanguage().id });

  if (loading || !data) return renderLoading();
  if (error) return renderError(error);

  return render({ data });
};

export type MySampleQueryContainerRenderProps = {
  data: any;
};

type Props = SmartComponentProps<{
  render: (props: any) => JSX.Element;
}>;
